import { h } from "preact";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import palette from "./palette";

// The `withStyles()` higher-order component is injecting a `classes`
// prop that is used by the `Button` component.

const NavPrimaryButtonTempMk2 = ({ txt, cb, disabled }) => {
	return (
		<Button
			variant="outlined"
			color="primary"
			style="border-radius: 24px; margin: 10px; text-transform: none; background-color: white; height: 48px;"
			onClick={cb}
			disabled={disabled}
		>
			{txt}
		</Button>
	);
};

const NavPrimaryButtonMk2 = withStyles({
	root: {
		color: palette.primary.main,
	},
	label: {
		textTransform: "none",
	},
})(NavPrimaryButtonTempMk2);

export default NavPrimaryButtonMk2;
